export default __webpack_public_path__ + "static/media/ligthening.1be2a464.png";